import { isNil, isEmpty } from 'ramda'

export const UrlUtils = {
  formatQueryParams: (filters: any) => {
    return Object.entries(filters)
      .filter(([_key, value]) => !isNil(value) && !isEmpty(value))
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  },
}
